import React from 'react';
import { CloseButtonContainer, VideoContent, WistiaContainer } from './OverlayVideo.styles';
import XClose from 'app/icons/Monospaced/X/XClose';
import { cssVar } from 'styles/helper';
import AssetWrapper from 'atoms/Asset/AssetWrapper';
import Stack from 'atoms/Layout/Stack/Stack';
import WistiaPlayer from 'molecules/WistiaPlayer/WistiaPlayer';
import ModalOverlay from 'molecules/BaseModal/ModalOverlay';

export interface OverlayVideoProps {
  visible?: boolean;
  setVisible: (visible: boolean) => void;
  vertical?: boolean;
  wistiaId?: string;
  src?: string;
}

const OverlayVideo = ({ visible, setVisible, vertical, wistiaId, src }: OverlayVideoProps): JSX.Element | null => {
  if (!visible) return null;

  const renderVideoPlayer = () => (
    <Stack
      paddingSm={['spacing-none', 'spacing-sm']}
      dataCy='video-player'
    >
      <AssetWrapper
        videoProps={{
          src,
          autoPlay: true,
          controls: true,
        }}
      />
    </Stack>
  );

  const renderWistiaPlayer = () => (
    <WistiaContainer
      $vertical={vertical}
      data-cy='wistia-container'
    >
      <WistiaPlayer
        videoId={wistiaId}
        autoPlay
        containerId={`overlay-video-wistia-id-${wistiaId}`}
      />
    </WistiaContainer>
  );

  return (
    <>
      <ModalOverlay onClick={() => setVisible(false)} />
      <VideoContent
        $vertical={vertical}
        data-cy='video-content'
      >
        <CloseButtonContainer
          onClick={() => setVisible(false)}
          dataCy='close-button'
        >
          <XClose
            width={24}
            color={cssVar('bg-primary')}
          />
        </CloseButtonContainer>
        {wistiaId ? renderWistiaPlayer() : renderVideoPlayer()}
      </VideoContent>
    </>
  );
};

export default OverlayVideo;
